import "moment-timezone";
import { createApp } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { PiniaSharedState } from "pinia-shared-state";
import VueNumberFormat from "@coders-tm/vue-number-format";
import { experimental_createPersister } from "@tanstack/query-persist-client-core";

import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import { IS_FRAMED_AEPP } from "./utils/constants";

const app = createApp(App);

const pinia = createPinia();
if (!IS_FRAMED_AEPP) {
  pinia.use(piniaPluginPersistedstate);

  pinia.use(
    PiniaSharedState({
      enable: false,
      initialize: false,
    })
  );
}

app.use(VueNumberFormat, { precision: 4 });
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        persister: experimental_createPersister({
          storage: window.localStorage,
        }),
      },
    },
  },
} as any);
app.use(pinia);
app.use(router);
app.use(i18n);
app.use(vuetify);

app.mount("#app");
